export default (number) => {
  return number.toLocaleString();
};
